// Cliente axios + endpoints del modulo Configuracion (Avisos, Empresa,
// Auditoria). Mismo patron liviano sin redux que usuariosApi.js.
import axios from "axios";
import { PATH } from "../../redux/utils";

export const apiConfiguracion = axios.create({ baseURL: PATH });

export const authHeaderConfiguracion = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const H = () => ({ headers: authHeaderConfiguracion() });

// ---------------------------------------------------------------------
// Avisos
// ---------------------------------------------------------------------
export const getAvisos = () => apiConfiguracion.get("/avisos", H());
export const crearAviso = (payload) => apiConfiguracion.post("/avisos", payload, H());
export const editarAviso = (id, payload) => apiConfiguracion.put(`/avisos/${id}`, payload, H());
export const eliminarAviso = (id) => apiConfiguracion.delete(`/avisos/${id}`, H());

// ---------------------------------------------------------------------
// Empresa (multipart: nombre_empresa + logo opcional)
// ---------------------------------------------------------------------
export const getConfiguracionEmpresa = () => apiConfiguracion.get("/configuracion-empresa", H());
export const putConfiguracionEmpresa = (formData) =>
  apiConfiguracion.put("/configuracion-empresa", formData, {
    headers: { ...authHeaderConfiguracion(), "Content-Type": "multipart/form-data" },
  });

// ---------------------------------------------------------------------
// Catalogos simples (canales-origen, tipos-estudio): nombre + baja logica
// ---------------------------------------------------------------------
export const getCatalogoSimple = (clave) => apiConfiguracion.get(`/catalogos-config/${clave}`, H());
export const crearCatalogoSimple = (clave, nombre) => apiConfiguracion.post(`/catalogos-config/${clave}`, { nombre }, H());
export const eliminarCatalogoSimple = (clave, id) => apiConfiguracion.delete(`/catalogos-config/${clave}/${id}`, H());
